"use strict";

var cov_1dirgp48wn = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\verse-objects\\AlignedWordsObject.js";
  var hash = "d6328b31438967211b7720445795ba67a4aa0147";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\verse-objects\\AlignedWordsObject.js",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 18
        },
        end: {
          line: 18,
          column: 29
        }
      },
      "1": {
        start: {
          line: 19,
          column: 34
        },
        end: {
          line: 19,
          column: 48
        }
      },
      "2": {
        start: {
          line: 21,
          column: 21
        },
        end: {
          line: 21,
          column: 67
        }
      },
      "3": {
        start: {
          line: 21,
          column: 32
        },
        end: {
          line: 21,
          column: 65
        }
      },
      "4": {
        start: {
          line: 22,
          column: 22
        },
        end: {
          line: 22,
          column: 50
        }
      },
      "5": {
        start: {
          line: 22,
          column: 30
        },
        end: {
          line: 22,
          column: 48
        }
      },
      "6": {
        start: {
          line: 24,
          column: 16
        },
        end: {
          line: 24,
          column: 25
        }
      },
      "7": {
        start: {
          line: 27,
          column: 29
        },
        end: {
          line: 27,
          column: 58
        }
      },
      "8": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 35,
          column: 3
        }
      },
      "9": {
        start: {
          line: 29,
          column: 93
        },
        end: {
          line: 29,
          column: 111
        }
      },
      "10": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 30,
          column: 44
        }
      },
      "11": {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 34,
          column: 8
        }
      },
      "12": {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 33,
          column: 42
        }
      },
      "13": {
        start: {
          line: 32,
          column: 22
        },
        end: {
          line: 32,
          column: 54
        }
      },
      "14": {
        start: {
          line: 33,
          column: 13
        },
        end: {
          line: 33,
          column: 42
        }
      },
      "15": {
        start: {
          line: 37,
          column: 16
        },
        end: {
          line: 41,
          column: 3
        }
      },
      "16": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 40,
          column: 11
        }
      },
      "17": {
        start: {
          line: 43,
          column: 18
        },
        end: {
          line: 43,
          column: 23
        }
      },
      "18": {
        start: {
          line: 45,
          column: 2
        },
        end: {
          line: 87,
          column: 3
        }
      },
      "19": {
        start: {
          line: 46,
          column: 17
        },
        end: {
          line: 46,
          column: 34
        }
      },
      "20": {
        start: {
          line: 47,
          column: 15
        },
        end: {
          line: 47,
          column: 43
        }
      },
      "21": {
        start: {
          line: 48,
          column: 27
        },
        end: {
          line: 50,
          column: 5
        }
      },
      "22": {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 49,
          column: 66
        }
      },
      "23": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 86,
          column: 6
        }
      },
      "24": {
        start: {
          line: 89,
          column: 2
        },
        end: {
          line: 93,
          column: 4
        }
      },
      "25": {
        start: {
          line: 96,
          column: 0
        },
        end: {
          line: 101,
          column: 2
        }
      },
      "26": {
        start: {
          line: 103,
          column: 18
        },
        end: {
          line: 118,
          column: 3
        }
      },
      "27": {
        start: {
          line: 103,
          column: 39
        },
        end: {
          line: 118,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "AlignedWordsObject",
        decl: {
          start: {
            line: 13,
            column: 9
          },
          end: {
            line: 13,
            column: 27
          }
        },
        loc: {
          start: {
            line: 17,
            column: 3
          },
          end: {
            line: 94,
            column: 1
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 21,
            column: 21
          },
          end: {
            line: 21,
            column: 22
          }
        },
        loc: {
          start: {
            line: 21,
            column: 30
          },
          end: {
            line: 21,
            column: 67
          }
        },
        line: 21
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 22,
            column: 22
          },
          end: {
            line: 22,
            column: 23
          }
        },
        loc: {
          start: {
            line: 22,
            column: 28
          },
          end: {
            line: 22,
            column: 50
          }
        },
        line: 22
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 24,
            column: 16
          },
          end: {
            line: 24,
            column: 17
          }
        },
        loc: {
          start: {
            line: 24,
            column: 22
          },
          end: {
            line: 24,
            column: 25
          }
        },
        line: 24
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 31,
            column: 16
          },
          end: {
            line: 31,
            column: 17
          }
        },
        loc: {
          start: {
            line: 31,
            column: 22
          },
          end: {
            line: 34,
            column: 7
          }
        },
        line: 31
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 37,
            column: 29
          },
          end: {
            line: 37,
            column: 30
          }
        },
        loc: {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 40,
            column: 11
          }
        },
        line: 38
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 48,
            column: 45
          },
          end: {
            line: 48,
            column: 46
          }
        },
        loc: {
          start: {
            line: 49,
            column: 6
          },
          end: {
            line: 49,
            column: 66
          }
        },
        line: 49
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 103,
            column: 29
          },
          end: {
            line: 103,
            column: 30
          }
        },
        loc: {
          start: {
            line: 103,
            column: 39
          },
          end: {
            line: 118,
            column: 1
          }
        },
        line: 103
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 35,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 35,
            column: 3
          }
        }, {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 35,
            column: 3
          }
        }],
        line: 28
      },
      "1": {
        loc: {
          start: {
            line: 32,
            column: 8
          },
          end: {
            line: 33,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 8
          },
          end: {
            line: 33,
            column: 42
          }
        }, {
          start: {
            line: 32,
            column: 8
          },
          end: {
            line: 33,
            column: 42
          }
        }],
        line: 32
      },
      "2": {
        loc: {
          start: {
            line: 38,
            column: 83
          },
          end: {
            line: 38,
            column: 122
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 38,
            column: 94
          },
          end: {
            line: 38,
            column: 110
          }
        }, {
          start: {
            line: 38,
            column: 113
          },
          end: {
            line: 38,
            column: 122
          }
        }],
        line: 38
      },
      "3": {
        loc: {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 87,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 87,
            column: 3
          }
        }, {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 87,
            column: 3
          }
        }],
        line: 45
      },
      "4": {
        loc: {
          start: {
            line: 47,
            column: 15
          },
          end: {
            line: 47,
            column: 43
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 47,
            column: 22
          },
          end: {
            line: 47,
            column: 31
          }
        }, {
          start: {
            line: 47,
            column: 34
          },
          end: {
            line: 47,
            column: 43
          }
        }],
        line: 47
      },
      "5": {
        loc: {
          start: {
            line: 58,
            column: 22
          },
          end: {
            line: 58,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 58,
            column: 29
          },
          end: {
            line: 58,
            column: 41
          }
        }, {
          start: {
            line: 58,
            column: 44
          },
          end: {
            line: 58,
            column: 58
          }
        }],
        line: 58
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "d6328b31438967211b7720445795ba67a4aa0147"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _Selections = require("../selections/Selections.context");

var _ = require(".");

function AlignedWordsObject(_ref) {
  var children = _ref.children,
      originalWords = _ref.originalWords,
      disableWordPopover = _ref.disableWordPopover;
  cov_1dirgp48wn.f[0]++;
  var classes = (cov_1dirgp48wn.s[0]++, useStyles());

  var _ref2 = (cov_1dirgp48wn.s[1]++, (0, _react.useState)(null)),
      _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
      anchorEl = _ref3[0],
      setAnchorEl = _ref3[1];

  cov_1dirgp48wn.s[2]++;

  var handleOpen = function handleOpen(event) {
    cov_1dirgp48wn.f[1]++;
    cov_1dirgp48wn.s[3]++;
    setAnchorEl(event.currentTarget);
  };

  cov_1dirgp48wn.s[4]++;

  var handleClose = function handleClose() {
    cov_1dirgp48wn.f[2]++;
    cov_1dirgp48wn.s[5]++;
    setAnchorEl(null);
  };

  cov_1dirgp48wn.s[6]++;

  var onClick = function onClick() {
    cov_1dirgp48wn.f[3]++;
  };

  var selected;

  var _selectionsContext = (cov_1dirgp48wn.s[7]++, (0, _react.useContext)(_Selections.SelectionsContext));

  cov_1dirgp48wn.s[8]++;

  if (_selectionsContext) {
    cov_1dirgp48wn.b[0][0]++;

    var _ref4 = (cov_1dirgp48wn.s[9]++, _selectionsContext),
        selections = _ref4.state,
        _ref4$actions = _ref4.actions,
        areSelected = _ref4$actions.areSelected,
        addSelections = _ref4$actions.addSelections,
        removeSelections = _ref4$actions.removeSelections;

    cov_1dirgp48wn.s[10]++;
    selected = areSelected(originalWords);
    cov_1dirgp48wn.s[11]++;

    onClick = function onClick() {
      cov_1dirgp48wn.f[4]++;
      cov_1dirgp48wn.s[12]++;

      if (selected) {
        cov_1dirgp48wn.b[1][0]++;
        cov_1dirgp48wn.s[13]++;
        removeSelections(originalWords);
      } else {
        cov_1dirgp48wn.b[1][1]++;
        cov_1dirgp48wn.s[14]++;
        addSelections(originalWords);
      }
    };
  } else {
    cov_1dirgp48wn.b[0][1]++;
  }

  var words = (cov_1dirgp48wn.s[15]++, children.map(function (verseObject, index) {
    cov_1dirgp48wn.f[5]++;
    cov_1dirgp48wn.s[16]++;
    return _react.default.createElement("span", {
      "data-test": "aligned-word-object",
      onClick: onClick,
      key: index,
      className: selected ? (cov_1dirgp48wn.b[2][0]++, classes.selected) : (cov_1dirgp48wn.b[2][1]++, undefined)
    }, _react.default.createElement(_.WordObject, {
      verseObject: verseObject,
      disableWordPopover: disableWordPopover
    }));
  }));
  var component = (cov_1dirgp48wn.s[17]++, words);
  cov_1dirgp48wn.s[18]++;

  if (!disableWordPopover) {
    cov_1dirgp48wn.b[3][0]++;
    var open = (cov_1dirgp48wn.s[19]++, Boolean(anchorEl));
    var id = (cov_1dirgp48wn.s[20]++, open ? (cov_1dirgp48wn.b[4][0]++, 'popover') : (cov_1dirgp48wn.b[4][1]++, undefined));

    var _originalWords = (cov_1dirgp48wn.s[21]++, originalWords.map(function (verseObject, index) {
      cov_1dirgp48wn.f[6]++;
      cov_1dirgp48wn.s[22]++;
      return _react.default.createElement(_.OriginalWordObject, {
        key: index,
        verseObject: verseObject
      });
    }));

    cov_1dirgp48wn.s[23]++;
    component = _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("span", {
      "aria-describedby": id,
      "aria-haspopup": "true",
      onMouseEnter: handleOpen,
      onMouseLeave: handleClose,
      className: open ? (cov_1dirgp48wn.b[5][0]++, classes.open) : (cov_1dirgp48wn.b[5][1]++, classes.closed)
    }, words), _react.default.createElement(_core.Popover, {
      id: id,
      open: open,
      anchorEl: anchorEl,
      onClose: handleClose,
      className: classes.popover,
      classes: {
        paper: classes.paper
      },
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      },
      disableRestoreFocus: true
    }, _react.default.createElement(_react.default.Fragment, null, _originalWords)));
  } else {
    cov_1dirgp48wn.b[3][1]++;
  }

  cov_1dirgp48wn.s[24]++;
  return _react.default.createElement(_react.default.Fragment, null, component);
}

cov_1dirgp48wn.s[25]++;
AlignedWordsObject.propTypes = {
  children: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  originalWords: _propTypes.default.arrayOf(_propTypes.default.object),

  /** disable popovers for aligned and original language words */
  disableWordPopover: _propTypes.default.bool
};
var useStyles = (cov_1dirgp48wn.s[26]++, (0, _styles.makeStyles)(function (theme) {
  cov_1dirgp48wn.f[7]++;
  cov_1dirgp48wn.s[27]++;
  return {
    open: {
      backgroundColor: 'lightgoldenrodyellow'
    },
    closed: {},
    popover: {
      pointerEvents: 'none'
    },
    paper: {
      padding: theme.spacing(1)
    },
    selected: {
      backgroundColor: 'yellow'
    }
  };
}));
var _default = AlignedWordsObject;
exports.default = _default;